import React from "react";
import { Button, Space } from "antd";

const NotificationsHeader: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 24,
      }}
    >
      <h2 style={{ fontSize: 24, fontWeight: 600 }}>
        Team + Client Notifications
      </h2>
      <Space>
        <Button type="primary">Templates</Button>
        <Button>Logs</Button>
        <Button>Settings</Button>
      </Space>
    </div>
  );
};

export default NotificationsHeader;
